export default __webpack_public_path__ + "static/media/Dyubanov_Anatoly_Vasilievich.e64157ed.webp";